import React from "react";

const LoadingSurah = ({ width }) => {
  return (
    <li
      className={` bg-white ${width} min-w-[160px] grow shrink-0  p-4 rounded-2xl cursor-pointer hover:scale-105 origin-bottom flex flex-col gap-2 animate-pulse`}
    >
      <div className=" flex justify-between items-center">
        <span className="text-sm relative flex items-center bg-[#F5F7F9] w-6 aspect-square rounded-md" />
        <button className="bg-[#F5F7F9] w-6 aspect-square rounded-md" />
      </div>
      <h3 className=" w-9/12 h-6 bg-[#F5F7F9]" />
    </li>
  );
};

export default LoadingSurah;
